export default "__VITE_ASSET__Cq5hp099__"